/**
 * Decodes a status message passed through the URL as
 * `encodeURIComponent(btoa(message))`. Returns undefined when the param is
 * empty or malformed (bad percent-encoding, not base64), so a hand-edited link
 * never crashes the page.
 */
export function decodeStatusParam(value) {
  if (!value) return undefined;
  try {
    return decodeURIComponent(atob(decodeURIComponent(value)));
  } catch {
    return undefined;
  }
}